import { render, staticRenderFns } from "./extensions.vue?vue&type=template&id=6bbbf636&scoped=true&"
import script from "./extensions.vue?vue&type=script&lang=js&"
export * from "./extensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbf636",
  null
  
)

export default component.exports